import $ from "jquery";
import { cardResizedAdjustVisualization } from "../cards";
// import adjustPieChartCenterText from "../util/adjust_pie_chart_title";
import toastr from "toastr";

let element;
let popover;
let form;
let newSlideDeckNameInput;

const setNewNameInputDisabled = function () {
  if ($(form).find("input[type=radio]:checked").val() === "-1") {
    newSlideDeckNameInput.prop("disabled", false);
    setTimeout(() => newSlideDeckNameInput.focus(), 0); // Doesn't work if called directly
  } else {
    newSlideDeckNameInput.prop("disabled", true);
  }
};

const radioButtonClicked = function () {
  setNewNameInputDisabled();
};

const formSuccess = function () {
  element.popover("hide");
  toastr.success("Slide added to deck.", "", {
    "positionClass": "toast-top-center",
  });
};

const formError = function () {
};

const convertToText = function (obj) {
  //create an array that will later be joined into a string.
  const string = [];

  //is object
  //  Both arrays and objects seem to return "object"
  //  when typeof(obj) is applied to them. So instead
  //  I am checking to see if they have the property
  //  join, which normal objects don't have but
  //  arrays do.
  let prop;
  if (obj == undefined) {
    return String(obj);
  } else if (typeof(obj) == "object" && (obj.join == undefined)) {
    for (prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        string.push(prop + ": " + convertToText(obj[prop]));
      }
    }

    return "{" + string.join(",") + "}";

  //is array
  } else if (typeof(obj) == "object" && !(obj.join == undefined)) {
    for(prop in obj) {
      string.push(convertToText(obj[prop]));
    }
    return "[" + string.join(",") + "]";

  //is function
  } else if (typeof(obj) == "function") {
    string.push(obj.toString());

  //all other values can be done with JSON.stringify
  } else {
    string.push(JSON.stringify(obj));
  }

  return string.join(",");
};

const loadData = function(url, cb) {
  $.ajax(url, {
    success: cb,
    error: (error) => {
      // eslint-disable-next-line
      console.log(error);
      window.alert("We're sorry, there was an error adding this card to a slide deck.");
    }
  });
};

const addToSlideDeckClicked = function (e) {
  e.preventDefault();
  const el = this;
  loadData($(el).data("content-url"), (data) => {
    // (BS5): BS3 re-read the `data-content` attr on each show; BS5 reads
    // `data-bs-content` once at init only, so push the AJAX-loaded form onto the
    // instance via `setContent`. `sanitize:false`/`html:true` (BS5 won't honour
    // those via data-attrs) keep the form's <input>/<form> from being stripped by
    // BS5's sanitizer. `add_to_slide_deck.js` is the SOLE driver (no data-bs-toggle
    // on the trigger), so getOrCreateInstance creates the instance with this config.
    const popover = window.bootstrap.Popover.getOrCreateInstance(el, {
      html: true,
      sanitize: false,
      placement: "top"
    });
    // BS5 moves the trigger's `title` to `data-bs-original-title` at init; setContent
    // REPLACES the content map, so include both the header (else it's dropped) and body.
    popover.setContent({
      ".popover-header": $(el).attr("data-bs-original-title") || $(el).attr("title") || "",
      ".popover-body": data
    });
    popover.show();
  });
};

const validateNewName = function () {
  const labels = $(".add_to_slide_deck > .popover-content-scrollable > .radio_buttons").children("span").find("label");
  const deckNameInput = $(".add_to_slide_deck_new_slide_deck_name").first().children("input");
  const addToDeckButton = $(".add_to_slide_deck input[type=submit].save");
  const newDeckName = deckNameInput.val();
  const existingDeckNames = [];
  for (let i = 0; i < labels.length; i++) {
    existingDeckNames.push(labels[i].innerText);
  }
  if (existingDeckNames.includes(newDeckName)) {
    addToDeckButton.prop("disabled", true);
    deckNameInput.css("box-shadow", "0 0 5px 5px #C84646");
    deckNameInput.css("border-color", "transparent");
  } else {
    addToDeckButton.prop("disabled", false);
    deckNameInput.css("box-shadow", "none");
    deckNameInput.css("border-color", "#66afe9");
  }
};

const popoverLoaded = function () {
  element = $(this);
  // (BS5): the tip is appended to <body> (not the trigger's parent) and
  // linked to the trigger by `aria-describedby` (set before `inserted.bs.popover`
  // fires), so resolve it by that id — `element.parent().find(".popover")` is empty.
  const tipId = element.attr("aria-describedby");
  popover = tipId ? $("#" + tipId) : $();
  form = popover.find("form");
  newSlideDeckNameInput = form.find("#add_to_slide_deck_new_slide_deck_name");
  newSlideDeckNameInput.on("keyup", validateNewName);
  form.find("input[type=radio]").on("click", radioButtonClicked);
  form.find(".cancel").on("click", () => element.popover("hide"));
  form.on("ajax:success", formSuccess);
  form.on("ajax:error", formError);
  setNewNameInputDisabled();

  const $card = $(this).closest("[data-card]");
  ///////////////////////////////////////////////////////////////////////
  // TODO(SI): use chartsFromCard and adjust for multi chart rendering //
  ///////////////////////////////////////////////////////////////////////
  const chart = $card.find("[data-highcharts-chart]").highcharts();

  const cardBody = $card.find(".card-body");
  let svg, chartOptions;

  if (chart) {
    chart.legendShow();
    cardBody.css("width", `${chart.options.exporting_options.width}px`);
    // cardBody.css("height", `${chart.options.exporting_options.height}px`);
    cardResizedAdjustVisualization(null, $card);
  }

  svg = $card.find("img:not(.secondary-visualization)").clone();
  if (svg.length == 0) svg = $card.find("svg:not(.secondary-visualization)").clone();

  svg.find("[visibility=hidden]").remove();
  svg.find(".highcharts-button").remove();
  chartOptions = svg.wrapAll("<div>").parent().html();

  // The page-level legacy #addToSlideDeckModal (slide_decks/_add_to_slide_deck_modal)
  // renders a SECOND input with this same id, so a global $("#add_to_slide_deck_chart_svg")
  // resolves by DOM order. BS3 inserted the tip next to the trigger (before the modal) so
  // the global lookup hit the tip's field; BS5 appends the tip to <body> END (after the
  // modal), so it now fills the modal's field and the popover form submits chart_svg="".
  // Scope the fill to the popover's own form.
  if (chart) {
    window.setTimeout(function () {
      form.find("#add_to_slide_deck_chart_svg").val(chartOptions);
      cardBody.css("width", "inherit");
      // cardBody.css("height", "inherit");
      cardResizedAdjustVisualization(null, $card);
    }, 0);
  } else {
    cardBody.css("width", "880px");
    form.find("#add_to_slide_deck_chart_svg").val(chartOptions);
    cardBody.css("width", "inherit");
  }

  cardResizedAdjustVisualization(null, $card);
};

// Prevent flash if reopening popover
const popoverHidden = function () {
  //element.popover("destroy");
};

const initSlides = function () {
  $(".add-to-slide-deck")
    .on("click", addToSlideDeckClicked)
    .on("inserted.bs.popover", popoverLoaded)
    .on("hidden.bs.popover", popoverHidden);
  // The BS3 issue-16732 reopen workaround (`$(e.target).data("bs.popover").inState`)
  // was removed: BS5 has no `.data("bs.popover")` (it threw) and fixed that reopen
  // bug natively.
};

$(document).on("turbolinks:load", initSlides);

export default initSlides;
